export const convertBlobToBase64 = (
    blob: Blob,
    callback: (base64String: string | ArrayBuffer | null) => void,
): void => {
    const reader = new FileReader()
    reader.onloadend = () => {
        const base64string = reader.result
        callback(base64string)
    }
    reader.readAsDataURL(blob)
}
